module.exports = __webpack_public_path__ + "static/media/kantoushan_package.ccaa91fe.webp";